export const MODULE = 'holidays'
export const LISTING_URL = ({branch_id, employee_id=''}) => {return {path: `holidays/index_list?branch_id=${branch_id}&employee_id=${employee_id}`, method: 'GET'}}
export const STORE_URL = () => {return {path: `${MODULE}`, method: 'POST'}}
export const HOLIDAYS_LIST = ({date, employee_id}) => {return {path: `api/employee-holidays?date=${date}&employee_id=${employee_id}`, method: 'GET'}}
